import React, { Component } from 'react';
import { Button } from '@pinpoint/design-kit';

import { withFixedTitle } from 'src/components';

import Gauge from 'src/charts/gauge';
import NormalDistribution from 'src/charts/normal_distribution';
import PxHistogram from 'src/charts/px_histogram';

const SquishlessGauge = withFixedTitle(Gauge);
const SquishlessNormalDistribution = withFixedTitle(NormalDistribution);

/* eslint-disable react/prop-types */

export default class ScoreChartContainer extends Component {
  constructor(props) {
    super(props);
    const { eventEmitter } = this.props;
    this.state = {
      viz: 'Gauge',
      selectedTrait: props.selectedTrait,
      selectedScore: props.selectedScore,
    };
    eventEmitter.subscribe('scoreChanged', (score) => {
      this.setState({
        selectedScore: score,
      });
    });
    eventEmitter.subscribe('traitChanged', (trait) => {
      this.setState({
        selectedTrait: trait,
      });
    });
  }

  render() {
    const { viz, selectedTrait, selectedScore } = this.state;
    const { style, styleOverride, pxHistograms, refresh } = this.props;
    const showPxHistogram =
      pxHistograms &&
      pxHistograms.length &&
      refresh &&
      refresh.pxHistograms &&
      refresh.pxHistograms.length &&
      selectedTrait.subType === 'facet';
    let pxHistogram = null;
    let populationHistogram = null;
    if (showPxHistogram) {
      pxHistogram = pxHistograms.find(({ trait }) => trait.code === selectedTrait.code);
      populationHistogram = refresh.pxHistograms.find(({ trait }) => trait.code === selectedTrait.code);
    }

    return (
      <>
        <Button
          zIndex="10"
          pos="absolute"
          top="1.25rem"
          right="1.5rem"
          bg="brand500"
          hoverBg="brand600"
          onClick={() => {
            if (viz === 'Gauge') {
              this.setState({ viz: 'Distribution' });
            } else {
              this.setState({ viz: 'Gauge' });
            }
          }}
        >
          {viz === 'Gauge' ? 'SCORE DISTRIBUTION' : 'SCORE METER'}
        </Button>
        {viz === 'Gauge' && (
          <SquishlessGauge
            title={selectedTrait.trait}
            label={selectedTrait}
            value={selectedScore}
            style={style}
            styleOverride={styleOverride}
          />
        )}
        {viz !== 'Gauge' && showPxHistogram && (
          <PxHistogram
            title={selectedTrait.triat}
            series={[
              {
                name: selectedTrait.trait,
                values: pxHistogram.frequencies,
              },
              {
                name: 'US Population',
                values: populationHistogram.frequencies,
              },
            ]}
            options={{
              legend: {
                left: 'center',
              },
              grid: {
                top: '15%',
              },
              series: [
                {
                  itemStyle: {
                    color: style.COLORS[selectedTrait.factor.toUpperCase()].PRIMARY,
                  },
                },
                {
                  itemStyle: {
                    color: '#A0A0A0',
                  },
                },
              ],
            }}
            showPaletteControl={false}
          />
        )}
        {viz !== 'Gauge' && !showPxHistogram && (
          <SquishlessNormalDistribution
            title={selectedTrait.trait}
            label={selectedTrait}
            value={selectedScore}
            style={style}
            styleOverride={styleOverride}
          />
        )}
      </>
    );
  }
}
